import P from "prop-types";

import { Apresentacao } from "./Apresentacao";
import { GraficosSession } from "./GraficosSession";
import { InfoText } from "./InfoText";

import * as Styles from "./styles";

export function PainelEstudoI({ hidden }) {
  if (hidden) {
    return <></>;
  } else {
    return (
      <Styles.Container>
        <Apresentacao />
        <InfoText />
        <GraficosSession />
      </Styles.Container>
    );
  }
}
PainelEstudoI.propTypes = {
  hidden: P.bool.isRequired,
};
